<template>
  <div>
    <div class="lead-coordinator cursor-pointer">
      <span class="info-bubbles">
        <span
        	v-for="(user, index) in deliverable.users"
          v-b-tooltip.hover.html
          :title="user.name"
          class="initials badge badge-primary"
          :class="getColorClass()"
        >
          <span class="exclude-outside-click">{{user.name | textInitials}}</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../routes";
export default {
  props: ["deliverable"],
  data() {
    return {
      changeCoordinatorFlag: false
    };
  },
  computed: {
    ...mapGetters(['userAbilities']),
    groupedUser() {
      let result = {};
      let users = this.deliverable.users;
      if(this.deliverable.lead_coordinator != null) {
        users.push(this.deliverable.lead_coordinator);
      }
      result = users.filter(
        (user, index, self) =>
          index ===
          self.findIndex(t => t.id === user.id && t.name === user.name)
      );
      return result;
    }
  },
  methods: {
    ...mapActions(["updateFieldValue", "changeLeadCoordinator"]),
    getTitle(contacts) {
      let title = "";
      contacts.forEach((contact, index) => {
        if (index >= 3) {
          title += contact.name + "<br>";
        }
        return title;
      });
      return title;
    },
    outside() {
      this.$set(this, "changeCoordinatorFlag", false);
    },
    getColorClass() {
      if (router.currentRoute.name == "myWeek") {
        return this.deliverable.lead_coordinator.id ==
          localStorage.getItem("userId")
          ? "badge-primary"
          : "other-user-badge";
      } else {
        return "badge-primary";
      }
    },
    showChangeCoordinator() {
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.changeCoordinatorFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableListUsers.$el.focus();
      });
    }
  }
};
</script>

<style>
</style>